








































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { mapGetters } from 'vuex'
import { EResidentStatus, EUserPermissions } from '@zunta/configurations'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import Card from '@/components/Card.vue'
import FacilityLabel from '@/components/labels/FacilityLabel.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import StatusResident from '@/components/statuses/StatusResident.vue'
import { RESIDENT_STATUS_LABEL_MAP } from '@/constants'

@Component({
  components: {
    StatusResident,
    Table,
    FacilityLabel,
    Card,
    ResidentLabel,
    DateTimeLabel
  },
  computed: {
    ...mapGetters({
      residentsList: 'resident/getResidents',
      residentsTotal: 'resident/getTotal'
    })
  }
})
export default class ManagementResidents extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  EResidentStatus = EResidentStatus
  EUserPermissions: any = EUserPermissions
  user = Api.getUser() as User

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: true,
    usePagination: true,
    rowClick: this.rowClick,
    fetchFunction: this.residentModuleInstance.getResidentsFilteredList,
    maxHeight: 'calc(100vh - 356px)',
    minHeight: '100px',
    columns: [
      {
        class: '',
        minWidth: '230px',
        width: 25,
        key: 'facility',
        searchKey: 'facilityName',
        hasSearch: true,
        label: 'Facility',
        hasSort: true,
        type: ETableColumnType.default
      },
      {
        class: '',
        minWidth: '150px',
        width: 17,
        key: 'resident',
        searchKey: 'residentName',
        hasSearch: true,
        label: 'Resident',
        hasSort: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 10,
        key: 'status',
        searchKey: 'status',
        hasSearch: true,
        label: 'Status',
        hasSort: true,
        type: ETableColumnType.select,
        options: [
          {
            content: RESIDENT_STATUS_LABEL_MAP[EResidentStatus.ACTIVE],
            key: EResidentStatus.ACTIVE,
            value: EResidentStatus.ACTIVE
          },
          {
            content: RESIDENT_STATUS_LABEL_MAP[EResidentStatus.INACTIVE],
            key: EResidentStatus.INACTIVE,
            value: EResidentStatus.INACTIVE
          }
        ]
      },
      {
        class: '',
        minWidth: '100px',
        width: 13,
        key: 'balance',
        searchKey: 'balance',
        hasSearch: true,
        label: 'Balance',
        hasSort: true,
        type: ETableColumnType.numberRange
      },
      {
        class: 'text-center',
        minWidth: '90',
        width: 9,
        key: 'stopSendingStatements',
        searchKey: 'stopSendingStatements',
        hasSearch: true,
        label: 'Stop sending statements',
        type: ETableColumnType.select,
        hasSort: true,
        options: [
          {
            key: 'Yes',
            content: 'Yes',
            value: true
          },
          {
            key: 'No',
            content: 'No',
            value: false
          }
        ]
      },
      {
        class: 'text-center',
        minWidth: '90px',
        width: 9,
        key: 'excludeFromCollections',
        searchKey: 'excludeFromCollections',
        hasSearch: true,
        label: 'Permanently exclude from collections flow',
        type: ETableColumnType.select,
        hasSort: true,
        options: [
          {
            key: 'Yes',
            content: 'Yes',
            value: true
          },
          {
            key: 'No',
            content: 'No',
            value: false
          }
        ]
      },
      {
        class: '',
        minWidth: '170px',
        width: 17,
        key: 'lastUpdate',
        searchKey: 'lastUpdate',
        hasSearch: true,
        label: 'Last Updated',
        hasSort: true,
        type: ETableColumnType.dateRange
      }
    ]
  }

  get filteredConfig () {
    const config = { ...this.config }
    const allowSettings = this.user.hasPermissionFor(EUserPermissions.EDIT_RESIDENT_SETTINGS)
    const allowCollections = this.user.hasPermissionFor(EUserPermissions.VIEW_COLLECTIONS)

    if (allowSettings && allowCollections) {
      return this.config
    }

    config.columns = config.columns.filter((column: any) => {
      return (column.key !== 'stopSendingStatements' && column.key !== 'excludeFromCollections') ||
          (column.key === 'stopSendingStatements' && allowSettings) ||
          (column.key === 'excludeFromCollections' && allowCollections)
    })
    const spareWidth = 100 - config.columns.reduce((acc: number, column: any) => column.width + acc, 0)
    if (spareWidth > 0) {
      const additionalColWidth: number = Number((spareWidth / config.columns.length).toFixed(2))
      config.columns = config.columns.map((column: any) => {
        return {
          ...column,
          width: column.width + additionalColWidth
        }
      })
    }
    return config
  }

  async rowClick (resident: any) {
    this.$locationManager.rememberLocation(this.$route.fullPath)
    const mirrorRoomId = localStorage.getItem('mirrorRoomId')
    const isMirrorActive = mirrorRoomId ? await this.residentModuleInstance.checkForActiveMirror(mirrorRoomId) : false
    if (mirrorRoomId && isMirrorActive) {
      await this.residentModuleInstance.pushResidentPageToMirror({ residentId: resident.id.toString(), mirrorRoomId })
    } else {
      this.$router.push({ name: 'management-resident', params: { id: resident.id.toString() } })
    }
  }

  async openMirror () {
    const mirrorRoomId = localStorage.getItem('mirrorRoomId')
    const isMirrorActive = mirrorRoomId ? await this.residentModuleInstance.checkForActiveMirror(mirrorRoomId) : false
    if (!isMirrorActive) {
      const routeData = this.$router.resolve({ name: 'mirror' })
      window.open(routeData.href, '_blank')
    }
  }
}
